import { render, staticRenderFns } from "./projectConfig.vue?vue&type=template&id=1c111fda&scoped=true"
import script from "./projectConfig.vue?vue&type=script&lang=js"
export * from "./projectConfig.vue?vue&type=script&lang=js"
import style0 from "./projectConfig.vue?vue&type=style&index=0&id=1c111fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c111fda",
  null
  
)

export default component.exports